import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    container: {
        paddingBottom: 60
    },
    rowContainer: {
        flex: 9,
        paddingRight: '5%',
        justifyContent: 'center'
    },
    programTime: {
        overflow: 'visible'
    },
    programTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 24,
        color: Theme.primaryTextColor,
        overflow: 'hidden'
    },
    programSubtitle: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        // marginBottom: 10,
        overflow: 'hidden'
    },
    smallerText: {
        fontSize: 18
    },
    programRow: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 20,
        // marginBottom: 10,
        paddingLeft: '5%',
        flex: 1
    },
    icon: {
        width: 50,
        height: 35
    },
    lock: {
        width: 27,
        height: 27,
        marginHorizontal: 11.5
    },
    lineIndicatorHolder: {
        width: '100%',
        height: 1,
        bottom: 0,
        position: 'absolute'
    },
    itemContainer: {
        flexDirection: 'row',
        width: '100%',
        // paddingTop: 10,
        paddingLeft: '5%',
        height: 70
    },
    highlightedItem: {
        backgroundColor: 'rgba(255, 255, 255, 0.3)'
    },
    noDataText: {
        top: '10%'
    },
    ...(!Device.isWeb
        ? {
              itemContainer: {
                  flexDirection: 'row',
                  width: '100%',
                  height: 65,
                  position: 'relative'
              }
          }
        : {})
};

export default StyleSheet.create(baseStyles);
